module.exports = __webpack_public_path__ + "static/media/template-brands.51c3b5bc.csv";